import React from "react";
import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { SITE, ABOUT_TEXT } from "@/lib/site";

export default function About() {
  return (
    <section id="ueber-uns" className="relative bg-surface py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          {/* Image left */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="lg:col-span-6 lg:sticky lg:top-28"
          >
            <div className="relative">
              <div className="absolute -inset-3 rounded-[2rem] bg-navy/5 -rotate-2" />
              <div className="relative rounded-[2rem] overflow-hidden bg-white shadow-2xl ring-1 ring-slate-200">
                <img
                  src={SITE.vehicle}
                  alt="Scharpf Firmenfahrzeug – Familie Scharpf"
                  className="w-full h-auto object-cover"
                  loading="lazy"
                />
              </div>
              <div className="absolute -bottom-6 -right-2 md:-right-6 bg-white rounded-2xl shadow-xl p-5 max-w-[260px] ring-1 ring-slate-200">
                <div className="text-xs font-bold uppercase tracking-[0.18em] text-slate-500">
                  Inhaber
                </div>
                <div className="font-heading text-2xl font-extrabold text-navy mt-1">
                  Kevin Scharpf
                </div>
              </div>
            </div>
          </motion.div>

          {/* Text right */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="lg:col-span-6"
          >
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white text-navy text-xs font-bold uppercase tracking-[0.2em] ring-1 ring-slate-200">
              <span className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: "#4ea83a" }} />
              {ABOUT_TEXT.eyebrow}
            </div>
            <h2 className="font-heading mt-5 text-4xl md:text-5xl lg:text-6xl font-black text-navy tracking-tight leading-[1.05]">
              {ABOUT_TEXT.heading1} <span className="text-shine">{ABOUT_TEXT.heading2}</span>
            </h2>
            <p className="mt-5 text-lg font-semibold text-slate-700 leading-relaxed">
              {ABOUT_TEXT.intro}
            </p>

            <div className="mt-6 space-y-4 text-base md:text-lg text-slate-700 leading-relaxed">
              {ABOUT_TEXT.paragraphs.map((p, i) => (
                <p key={i}>{p}</p>
              ))}
            </div>

            <div className="mt-8 p-6 rounded-2xl bg-white ring-1 ring-slate-200 shadow-sm">
              <div className="font-heading text-xl font-bold text-navy">
                Warum Scharpf Haushaltsauflösungen & Entrümpelungen?
              </div>
              <ul className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-3">
                {ABOUT_TEXT.reasons.map((r, i) => (
                  <li key={i} className="flex items-start gap-3 text-slate-800">
                    <span
                      className="mt-0.5 flex-shrink-0 w-6 h-6 rounded-full flex items-center justify-center"
                      style={{ backgroundColor: "rgba(78,168,58,0.15)" }}
                    >
                      <Check className="w-4 h-4" style={{ color: "#3d8a2c" }} strokeWidth={3} />
                    </span>
                    <span className="text-sm md:text-base font-medium">{r}</span>
                  </li>
                ))}
              </ul>
            </div>

            <p className="mt-6 text-base md:text-lg text-slate-700 leading-relaxed">
              {ABOUT_TEXT.outro}
            </p>

            <div
              className="mt-6 p-5 rounded-2xl text-center"
              style={{ background: "linear-gradient(135deg, #1e3a5f 0%, #142a47 100%)", color: "#ffffff" }}
            >
              <div className="font-heading text-lg md:text-xl font-bold">
                Scharpf Haushaltsauflösungen & Entrümpelungen
              </div>
              <div className="mt-1 text-sm md:text-base text-white/80">{ABOUT_TEXT.claim}</div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
